import { useAuth0 } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { AuthContext, AuthContextType } from './AuthContext';

export function Auth0AuthContext({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, getAccessTokenSilently } = useAuth0();

  const value: AuthContextType = {
    isAuthenticated: !!isAuthenticated,
    isLoading: !!isLoading,
    loginWithRedirect: loginWithRedirect as AuthContextType['loginWithRedirect'],
    logout: logout as AuthContextType['logout'],
    getAccessTokenSilently: getAccessTokenSilently as AuthContextType['getAccessTokenSilently'],
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
